import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { getDefaultStore } from 'jotai';
import { useEffect } from 'react';

import { analytics } from '@/features/analytics/service';
import {
  onboardingDataAtom,
  onboardingDoneAtom,
} from '@/features/onboarding/atoms/steps';
import { OnboardingFormProvider } from '@/features/onboarding/components/onboardingForm/onboardingFormProvider';
import { sanitizeOnboarding } from '@/features/onboarding/utils/steps';
import { getMyProfileOptions } from '@/features/profile/hooks/useGetMyProfile/getMyProfile.options';

export const Route = createFileRoute('/_protected/onboarding')({
  component: OnboardingLayout,
  beforeLoad: async ({ context }) => {
    // Check if user already has profile - redirect to app
    const { profile } = await context.queryClient.ensureQueryData(
      getMyProfileOptions(),
    );
    if (profile) {
      throw redirect({ to: '/', replace: true });
    }

    // Sanitize onboarding state
    const store = getDefaultStore();
    const onboardingData = store.get(onboardingDataAtom);
    const onboardingDone = store.get(onboardingDoneAtom);
    const { doneChanged, cleanedDone, cleanedData, dataChanged } =
      sanitizeOnboarding(onboardingData, onboardingDone);
    if (doneChanged) {
      store.set(onboardingDoneAtom, cleanedDone);
    }
    if (dataChanged) {
      store.set(onboardingDataAtom, cleanedData);
    }
  },
  shouldReload: false,
  gcTime: 0,
});

function OnboardingLayout() {
  useEffect(() => {
    analytics.captureEvent('Duos Onboarding Started', {});
  }, []);

  return (
    <div className="w-full overflow-x-hidden">
      <OnboardingFormProvider>
        <Outlet />
      </OnboardingFormProvider>
    </div>
  );
}
